<template>
  <div class="header">
    <div class="left">
      <img src="../../public/images/top-left.png" alt="" />
      <dv-decoration-6 class="decoration" :color="['rgba(51,147,255,0.8)', 'rgba(51,147,255,0.5)']" />
      <!-- <div class="weather">小雨 18-25℃ 北风1-3级</div> -->
    </div>
    <div class="middle">
      <span>竹产业供应链服务平台</span>
    </div>
    <div class="right">
      <img src="../../public/images/top-right.png" alt="" />
      <dv-decoration-6 class="decoration" :color="['rgba(51,147,255,0.8)', 'rgba(51,147,255,0.5)']" />

      <div class="time-wrap">
        <dv-decoration-1 :color="['white', '#00ffff']" style="width: 150px; height: 30px" />
        <div class="time">{{ currentTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderBar',
  data() {
    return {
      currentTime: '',
      timerId: null,
    };
  },
  created() {},
  mounted() {
    this.updateTime();
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    this.timerId = setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      this.currentTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
    },

    async getWeatherByWebApi(cityCode) {
      try {
        const response = await this.$http.get('https://restapi.amap.com/v3/weather/weatherInfo', {
          params: {
            city: cityCode, // 城市adcode，如 '110101'（北京东城区）
            key: '737f19d5c3acfc68f4927d900d2d280d', // 你的高德Key
            extensions: 'base', // 'base':实时天气；'all':预报天气
          },
        });
        if (response.data.status === '1') {
          this.weatherData = response.data.lives[0];
        } else {
          console.error('WebAPI获取天气失败:', response.data.info);
        }
      } catch (error) {
        console.error('请求WebAPI出错:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 98%;
  margin: 0 auto;
  padding: 10px 0 0 0;
  position: relative;
  .middle {
    margin: 0 auto;
    width: 620px;
    height: 90px;
    background: url('../../public/images/top-middle.png') no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    color: #ffffff;
    font-size: 34px;
    letter-spacing: 8px;
    font-style: italic;
    font-weight: 600;
    span {
      padding-top: 12px;
      display: block;
    }
  }
  .left,
  .right {
    position: absolute;
    top: 0;
    width: 674px;
    img {
      height: 60px;
    }
    .decoration {
      width: 100px;
      height: 14px;
      position: absolute;
      top: 20px;
    }
  }
  .left {
    left: 0;
    .decoration {
      left: 10px;
    }
    .weather {
      color: #ffffff;
      font-size: 15px;
      position: absolute;
      left: 50px;
      bottom: -10px;
    }
  }
  .right {
    right: 0;
    .decoration {
      right: 10px;
    }
    .time-wrap {
      color: #ffffff;
      font-size: 15px;
      position: absolute;
      right: 50px;
      bottom: -10px;
      display: flex;
      align-items: center;
      .time {
        margin-left: 20px;
      }
    }
  }
}
</style>
